import axios from "axios";
import { API } from "../../utils/index";
const instance = axios.create();

export const getCarrousels = async () => {
  const _endpoint = "carrousel";
  const URL = `${API}/${_endpoint}`;
  return instance.get(URL);
};
